import React from "react";
import s from './billcsstest.module.css';


export default function Billcsstest() {
	
	return (
		<div className={s.container}>
					<div className={s.billBtn1}>
						<div className={s.billSubBtn1}>Hit</div>
					</div>
		</div>
	);
}
